import { useAddBahamut, useWeb3 } from '@/hooks'
import { Button, HStack, Tooltip } from '@chakra-ui/react'
import { Footer as SharedFooter } from '@erinaceus/ui'
import { useAccount } from 'wagmi'

export const Footer = ({ ...props }) => {
  const { addBahamut } = useAddBahamut()
  const { isConnected } = useAccount()
  const { chain, isCorrectChain, isSupportedNetwork } = useWeb3()

  const onCorrectChain = isCorrectChain && isSupportedNetwork

  return (
    <SharedFooter {...props}>
      <HStack spacing={'12px'}>
        <Tooltip
          isDisabled={isConnected && !onCorrectChain}
          label={
            onCorrectChain
              ? `You are already on ${chain?.name}!`
              : 'First connect wallet!'
          }
        >
          <Button
            isDisabled={!isConnected || onCorrectChain}
            onClick={() => addBahamut()}
            variant={'solid'}
          >
            Add {chain?.name}
          </Button>
        </Tooltip>
      </HStack>
    </SharedFooter>
  )
}
